<div class="trinka_cloud_wrap">
    <div id="particles-js"></div>
    <div class="cloud_top_banners">
        <div class="container">
            <div class="row">
                <div class="col-lg-8">
                    <div class="trinka_cloud_banner_text">
                        <h1>学生写作助手。<br />
                            让教师评估更轻松。</h1>
                        <p>Trinka的先进人工智能不仅可以帮助学生提高写作水平，还可以在写作时学习最佳的学术写作范例，教师也能受益于自动评估和对写作的深度重点反馈。
                        </p>
                        <button style="margin: 0; padding: 0;" (click)="sectionValue('Enterprise Form')" id="salesContactButtons" data-toggle="modal"
                            data-target="#EnterPriseContactPopup" class="plansButtons" type="submit">获取报价</button>
                    </div>
                </div>
                <div class="col-lg-4">
                    <div class="trinka_cloud_banner_img">
                        <img src="assets/images/K12-and-elearning.png" alt="Trinka enterprise" class="img-fluid">
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="most_suited_for_section">
        <div class="container">
            <div class="row">
                <div class="col-lg-4">
                    <div class="most_united_heading">
                        <h2>
                            <span></span>行业定制解决方案</h2>
                    </div>
                </div>
                <div class="col-lg-8">
                    <div class="most_suited_point">
                        <ul>
                            <li>学校/K-12</li>
                            <li>学院</li>
                            <li>英语语言学习APP</li>
                            <li>电子化学习平台</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="brandLogo_sections">
        <div class="container">
            <div class="row">
                <div class="col-sm-2">
                    <h2>深受全球领导者信赖</h2>
                </div>
                <div class="col-sm-10">
                    <div class="cover_wrapper">
                        <div id="client-logos-enterprise" class="owl-carousel">
                            <div class="item">
                                <div class="client-inners">
                                    <img src="assets/images/client_logos/paterson.png" alt="">
                                </div>
                            </div>

                            <div class="item">
                                <div class="client-inners">
                                    <img src="assets/images/client_logos/abraham-lincoln.png" alt="">
                                </div>
                            </div>
                            <!-- <div class="item">
                                <div class="client-inners">
                                    <img src="assets/images/client_logos/AmericanCollegeofGreece.png" alt="">
                                </div>
                            </div> -->
                            <div class="item">
                                <div class="client-inners">
                                    <img src="assets/images/client_logos/act.png" alt="">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="assets/images/client_logos/AguaFriaUnion.png" alt="">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="assets/images/client_logos/almosa.png" alt="">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="assets/images/client_logos/amalAcademy.png" alt="">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="assets/images/client_logos/AmericanschoolofDubai.png" alt="">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="assets/images/client_logos/lusaka.png" alt="">
                                </div>
                            </div>

                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
    <div class="wayToIntegrateTrinka">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="integreate_heading_section">
                        <h2>为学生和教职员工提供高质量的写作帮助</h2>
                        <div class="HeadingSubLine"></div>
                        <p>Trinka帮助学生更好地创造和学习学术写作的相关标准，教师也能获得有关学生写作的深入报告。</p>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-12">
                    <ul>
                        <li>
                            <div class="features_cards">
                                <div class="features_cards_icon">
                                    <img src="assets/images/Real-timewritingsuggestions.png" alt="" srcset="">
                                </div>
                                <div class="features_cards_desc">
                                    <h3>给学生的实时写作建议</h3>
                                    <p>Trinka专为学术写作而打造，不仅能纠正复杂的语法错误，还能改善词汇、语气、句法等，学生也可以从详细的建议中学习。</p>
                                </div>
                            </div>
                        </li>

                        <li>
                            <div class="features_cards">
                                <div class="features_cards_icon">
                                    <img src="assets/images/Qualityassessment.png" alt="" srcset="">
                                </div>
                                <div class="features_cards_desc">
                                    <h3>可定制的学生写作质量分数</h3>
                                    <p>让学生通过可定制的评分算法实时了解他们的写作质量。Trinka能提供详细的解释和实时的建议帮助学生学习，并且提高他们的写作水平。
                                    </p>
                                </div>
                            </div>
                        </li>
                        <li>
                            <div class="features_cards">
                                <div class="features_cards_icon">
                                    <img src="assets/images/Automatedfilecorrections.png" alt="" srcset="">
                                </div>
                                <div class="features_cards_desc">
                                    <h3>自动文件更正和错误报告</h3>
                                    <p>只需上传微软Word文档，即可在几分钟内获取带有跟踪更改的编辑文件以及所有错误的详细报告。Trinka使评估写作和提供反馈更快更容易。</p>
                                </div>
                            </div>
                        </li>
                        <li>
                            <div class="features_cards">
                                <div class="features_cards_icon">
                                    <img src="assets/images/ComprehensiveAnalytics.svg" alt="" srcset="">
                                </div>
                                <div class="features_cards_desc">
                                    <h3>综合分析</h3>
                                    <p>了解您的学生如何使用Trinka或通过丰富的分析手段深入了解每个学生的活动，以进行有效的评估和反馈。</p>
                                </div>
                            </div>
                        </li>
                        <li>
                            <div class="features_cards">
                                <div class="features_cards_icon">
                                    <img src="assets/images/ppc_icon.png" width="40" height="40" alt="" srcset="">
                                </div>
                                <div class="features_cards_desc">
                                    <h3>抄袭检测</h3>
                                    <p>先进的文本相似性检测算法，高质量的抄袭检查， iThenticate技术支持，最大的付费出版物数据库。
                                    </p>
                                </div>
                            </div>
                        </li>
                        <li>
                            <div class="features_cards">
                                <div class="features_cards_icon">
                                    <img src="assets/images/FileLevelRestrictions.svg" alt="" srcset="">
                                </div>
                                <div class="features_cards_desc">
                                    <h3>文件级别控制</h3>
                                    <p>通过Trinka对内部学生和远程学习者的细化控制，访问管理变得简单而安全。</p>
                                </div>
                            </div>
                        </li>
                        <li>
                            <div class="features_cards">
                                <div class="features_cards_icon">
                                    <img src="assets/images/EasyUserManagement.svg" alt="" srcset="">
                                </div>
                                <div class="features_cards_desc">
                                    <h3>易于管理</h3>
                                    <p>Trinka可让您在几秒钟内管理访问、交换许可证或添加成员，并为您自动完成其余工作。</p>
                                </div>
                            </div>

                        </li>
                        <li>
                            <div class="features_cards">
                                <div class="features_cards_icon">
                                    <img src="assets/images/DedicatedSupport.svg" alt="" srcset="">
                                </div>
                                <div class="features_cards_desc">
                                    <h3>专门的支持</h3>
                                    <p>指定一名专门的成经验丰富的经理来帮助您的团队充分利用Trinka，包括详细的产品熟悉过程、帮助文档和视频演练。</p>
                                </div>
                            </div>
                        </li>

                    </ul>
                    <span class="bottom_diviedLine"></span>
                    <span class="bottom_diviedLine1"></span>
                </div>
            </div>

        </div>
    </div>
</div>

<div class="advanceGrammerSpellCheck_section backgrondSecitons_outer accomplishSections sec2">
    <div class="container">
        <div class="row">
            <div class="col-xl-4">
                <div class="spellcheck_heading EnhancementsHeadingSection">
                    <h2>Trinka企业版适用于K-12和电子化学习</h2>
                    <div class="HeadingSubLine"></div>
                    <p>通过定制功能挖掘Trinka为教育平台带来的真正力量。</p>
                </div>
            </div>
            <div class="col-xl-8">
                <div class="all_usecases">
                    <div class="row">
                        <div class="col-md-6">
                            <div class="all_usecases_item">
                                <h4>跟踪学习进度</h4>
                                <p>随着时间的推移，通过丰富的评估手段和跟踪每个学生的写作改进。</p>
                                <ul>
                                    <li>写作质量得分</li>
                                    <li>按语法类别进行分类的错误报告</li>
                                    <li>对学生有益的更正和建议</li>
                                </ul>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="all_usecases_item">
                                <h4>识别学习差距</h4>
                                <p>通过对错误类型和频率的分析以及可定制的写作质量分数来确定个人学习的需求。</p>
                                <ul>
                                    <li>可定制的自动写作质量评分算法</li>
                                    <li>按语法类别进行分类的错误报告</li>
                                    <li>跟踪更正以进行评估和反馈</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="all_usecases_item all_usecases_item_last">
                                <h4>实时学习支持</h4>
                                <p>Trinka的人工智能可以实时评估写作并立即提供更正和建议，帮助学习者识别错误并且改进，养成更好的写作实践。</p>
                                <ul>
                                    <li>情境学习机会</li>
                                    <li>带有详细解释的更正建议</li>
                                    <li>互动的写作质量评分</li>

                                </ul>
                            </div>
                        </div>

                    </div>
                </div>
            </div>


        </div>
    </div>
</div>

<div class="softWare_workFlow cloud_key_features">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="brandlogo_heading key_features_heading">
                    <h2>无论学习者在何处写作，Trinka都可以为您提供写作协助</h2>
                </div>
                <div class="HeadingSubLine"></div>
                <p>Trinka可在各种平台上访问，让学习者无论在何处写作——从浏览器到微软Word，都能从Trinka强大的写作帮助中受益。</p>
            </div>
        </div>
        <div class="row">
            <div class="col-md-4">
                <div class="features_cards">

                    <h3>云编辑器</h3>

                    <p>通过基于Web的安全应用程序，在任何地方都可以充分利用Trinka的强大潜力。</p>
                </div>
            </div>
            <div class="col-md-4">
                <div class="features_cards">
                    <h3>微软Word插件</h3>
                    <p>通过在微软Word中提供写作建议来提高团队的工作效率。</p>
                </div>
            </div>
            <div class="col-md-4">
                <div class="features_cards">

                    <h3>浏览器插件</h3>
                    <p>插件适用于所有受欢迎的浏览器，为您在任何网站提供实时的写作帮助。</p>

                </div>
            </div>
        </div>
    </div>
</div>

<div class="most_suited_for_section pricing_works">
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="brandlogo_heading">
                    <h2>适合您的个性化定价</h2>
                </div>
                <p>Trinka提供基于用户数量或使用情况的灵活定价，以满足用户的独特需求。</p>
                <p>您可以实时切换用户并应用使用限制，而无需额外费用。<br />
                    我们将与您合作，通过采购订单或者发票轻松定制合同和单一付款选项。</p>
            </div>

            <div class="col-lg-12">
                <div class="try_trinka_Buttons">
                    <!-- <a href="https://cloud.trinka.ai/signup?_rg=CN" target="_blank">Get a Quote</a> -->

                    <button style="margin: 0; padding: 0;" (click)="sectionValue('Enterprise Form')" id="salesContactButtons" data-toggle="modal"
                        data-target="#EnterPriseContactPopup" class="plansButtons" type="submit">获取报价</button>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="writeToolboxs_section">
    <div class="writeToolbox_inner_sections">
        <div class="container">
            <div class="row">
                <div class="col-lg-7">
                    <div class="toolbox_text_content">
                        <h3>安全、可靠、值得信赖</h3>
                        <p>Trinka将数据安全和隐私放在首位。您的所有数据都经过高度加密并安全存储，没有其他人能够访问您的数据。我们提供独有的方案，一旦送给您写作建议，我们就会完全删除保存的数据。
                        </p>
                    </div>
                </div>
                <div class="col-lg-5">
                    <div class="toolbox_img_content">
                        <img src="assets/images/safe-secure.png" alt="" class="img-fluid">
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="writeToolbox_inner_sections sections_height_set publicationCheckSections" style="background-image: url('../../../assets/images/toolbox_backgrond_browser_plugin_r.png');">
        <div class="container">
            <div class="row">
                <div class="col-lg-5">
                    <div class="toolbox_img_content">
                        <img src="assets/images/about-ai.png" alt="" class="img-fluid">
                    </div>
                </div>
                <div class="col-lg-7">
                    <div class="toolbox_text_content">
                        <h3>关于人工智能</h3>
                        <p>Trinka使用最新的机器学习(ML)和自然语言处理(NLP)技术来识别语法错误并提出语言改进建议。Trinka是数百万篇优秀论文和文章的训练成果。它涵盖了1300多个学科领域，包括医学、生命科学、生物学、物理科学、工程、人文、商业和艺术，能为您提供最相关的建议。</p>
                        <p>Trinka由语言学家、医学编辑、数据科学家和工程师组成的团队开发而成，他们深切希望通过无障碍沟通创造未来。</p>

                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="enterprise_contactUs">
    <p>Trinka让您的学生更好地写作</p>
    <button (click)="sectionValue('Enterprise Form')" id="salesContactButtons" data-toggle="modal" data-target="#EnterPriseContactPopup"
        class="plansButtons" type="submit">获取报价</button>
</div>



<div class="modal custom_modal_popup enterprisePopup" id="EnterPriseContactPopup">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-body">
                <div class="closed_icons">
                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                </div>
                <div class="row">
                    <div class="col-sm-12">
                        <div class="contactPopupHeading">
                            <h2>企业咨询</h2>
                            <p *ngIf="formSection">请问您要咨询什么？</p>
                        </div>
                    </div>
                    <div class="inquiryTypeSection">
                        <ul class="nav nav-tabs" role="tablist" *ngIf="formSection">
                            <li class="nav-item">
                                <a class="nav-link" data-toggle="tab" href="#IndividualType" role="tab">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50">
                                        <defs>
                                            <style>
                                                .cls-1 {
                                                    fill: none;
                                                    stroke: #783694;
                                                    stroke-linecap: round;
                                                    stroke-linejoin: round;
                                                    stroke-width: 2px;
                                                }
                                            </style>
                                        </defs>
                                        <title>TrinkaIcons-new</title>
                                        <g id="Individual">
                                            <path class="cls-1"
                                                d="M44.83,45.13V39.82a4.65,4.65,0,0,0-1.7-3.6,62.85,62.85,0,0,0-10.89-7V22.5a4.4,4.4,0,0,0,1.56-3.36V11.39A7.9,7.9,0,0,0,25.91,3.5H24.24a7.9,7.9,0,0,0-7.89,7.89v7.75a4.32,4.32,0,0,0,1.54,3.36h0v6.68A62.22,62.22,0,0,0,7,36.22a4.62,4.62,0,0,0-1.7,3.6v5.31" />
                                        </g>
                                    </svg>
                                    <div class="text-left">
                                        <h3>个人</h3>
                                        <span>（单用户）</span>
                                    </div>
                                </a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" data-toggle="tab" href="#OrganizationType" role="tab">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50">
                                        <defs>
                                            <style>
                                                .cls-1 {
                                                    fill: none;
                                                    stroke: #783694;
                                                    stroke-linecap: round;
                                                    stroke-linejoin: round;
                                                    stroke-width: 2px;
                                                }
                                            </style>
                                        </defs>
                                        <title>TrinkaIcons-new</title>
                                        <g id="Organization">
                                            <path class="cls-1"
                                                d="M42.87,45.13V40.06a4.45,4.45,0,0,0-1.62-3.44,60,60,0,0,0-10.41-6.72V23.51a4.2,4.2,0,0,0,1.49-3.21V12.89a7.55,7.55,0,0,0-7.54-7.54H23.19a7.55,7.55,0,0,0-7.54,7.54V20.3a4.13,4.13,0,0,0,1.47,3.21h0v6.38A59.44,59.44,0,0,0,6.71,36.62a4.42,4.42,0,0,0-1.62,3.44v5.07" />
                                            <path class="cls-1"
                                                d="M14.34,30.75a24.56,24.56,0,0,0-3.32-2V26.18a1.66,1.66,0,0,0,.59-1.27V22a3,3,0,0,0-3-3H8a3,3,0,0,0-3,3v2.93a1.63,1.63,0,0,0,.58,1.27h0v2.53a23.54,23.54,0,0,0-4.12,2.66,1.75,1.75,0,0,0-.64,1.36v2" />
                                            <path class="cls-1"
                                                d="M34.29,30.75a24.56,24.56,0,0,1,3.32-2V26.18A1.66,1.66,0,0,1,37,24.91V22a3,3,0,0,1,3-3h.63a3,3,0,0,1,3,3v2.93A1.63,1.63,0,0,1,43,26.18h0v2.53a23.54,23.54,0,0,1,4.12,2.66,1.75,1.75,0,0,1,.64,1.36v2" />
                                        </g>
                                    </svg>
                                    <div class="text-left">
                                        <h3>组织</h3>
                                        <span>（多用户）</span>
                                    </div>
                                </a>
                            </li>
                        </ul>
                        <div class="tab-content">
                            <div class="tab-pane" id="IndividualType" role="tabpanel" *ngIf="formSection">
                                <div class="IndividualTypeSection">
                                    <p>Trinka对于个人用户是免费的，<br />您只需注册您的电子邮件地址即可。</p>
                                    <a href="https://cloud.trinka.ai/signup?_rg=CN" target="_blank">免费注册</a>
                                </div>
                            </div>
                            <div class="tab-pane" id="OrganizationType" role="tabpanel" *ngIf="formSection">
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="contact_us_form">
                                            <form [formGroup]="contactForm" (ngSubmit)="sendContactUsForm()">
                                                <h2>请在下面提出您的要求，我们的团队将及时回复。</h2>
                                                <div class="row">
                                                    <div class="col-md-6 rightPaddingRemove">
                                                        <div class="textbox_content form-group"
                                                            [ngClass]="(!contactForm.get('NatureBusinessType').valid && contactForm.get('NatureBusinessType').dirty) || (contactForm.get('NatureBusinessType').touched && contactForm.get('NatureBusinessType').pristine) ? 'TextFiledError' : '' ">
                                                            <mat-form-field appearance="outline">
                                                                <mat-label>业务性质*</mat-label>
                                                                <input matInput placeholder=""
                                                                    formControlName="NatureBusinessType"
                                                                    class="form-control">
                                                            </mat-form-field>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6 leftPaddingRemove">
                                                        <div class="textbox_content form-group"
                                                            [ngClass]="(!contactForm.get('contactFormSubjects').valid && contactForm.get('contactFormSubjects').dirty) || (contactForm.get('contactFormSubjects').touched && contactForm.get('contactFormSubjects').pristine) ? 'TextFiledError' : '' ">
                                                            <mat-form-field appearance="outline">
                                                                <mat-label>单位名称*</mat-label>
                                                                <input matInput placeholder=""
                                                                    formControlName="contactFormSubjects"
                                                                    class="form-control">
                                                            </mat-form-field>
                                                        </div>
                                                    </div>
                                                    <!-- <div class="col-md-12">
                                                        <div class="textbox_content form-group textareaBox"
                                                            [ngClass]="(!contactForm.get('contactFormMessage').valid && contactForm.get('contactFormMessage').dirty) || (contactForm.get('contactFormMessage').touched && contactForm.get('contactFormMessage').pristine) ? 'TextFiledError' : '' ">
                                                            <mat-form-field appearance="outline">
                                                                <mat-label>请告诉我们您的要求..*</mat-label>
                                                                <textarea
                                                                    title="例如。大约的用户数，每个用户的每月处理字数，所需的自定义设置等。"
                                                                    matInput formControlName="contactFormMessage"
                                                                    placeholder="" class="form-control"></textarea>
                                                            </mat-form-field>
                                                        </div>
                                                    </div> -->
                                                    <div class="col-md-12">
                                                        <div class="textbox_content form-group textareaBox"
                                                            [ngClass]="(!contactForm.get('contactFormMessage').valid && contactForm.get('contactFormMessage').dirty) || (contactForm.get('contactFormMessage').touched && contactForm.get('contactFormMessage').pristine) ? 'TextFiledError' : '' ">
                                                            <label for="">请告诉我们您的要求..*</label>
                                                            <textarea formControlName="contactFormMessage"
                                                                class="form-control"
                                                                placeholder="例如。大约的用户数，每个用户的每月处理字数，所需的自定义设置等。"></textarea>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6 rightPaddingRemove">
                                                        <div class="textbox_content form-group"
                                                            [ngClass]="(!contactForm.get('contactFormName').valid && contactForm.get('contactFormName').dirty) || (contactForm.get('contactFormName').touched && contactForm.get('contactFormName').pristine) ? 'TextFiledError' : '' ">
                                                            <mat-form-field appearance="outline">
                                                                <mat-label>您的姓名 *</mat-label>
                                                                <input matInput placeholder=""
                                                                    formControlName="contactFormName"
                                                                    class="form-control">
                                                            </mat-form-field>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6 leftPaddingRemove">
                                                        <div class="textbox_content form-group"
                                                            [ngClass]="(!contactForm.get('DesignationTypes').valid && contactForm.get('DesignationTypes').dirty) || (contactForm.get('DesignationTypes').touched && contactForm.get('DesignationTypes').pristine) ? 'TextFiledError' : '' ">
                                                            <mat-form-field appearance="outline">
                                                                <mat-label>指定*</mat-label>
                                                                <input matInput placeholder=""
                                                                    formControlName="DesignationTypes"
                                                                    class="form-control">
                                                            </mat-form-field>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6 rightPaddingRemove">
                                                        <div class="textbox_content form-group"
                                                            [ngClass]="(!contactForm.get('contactFormEmail').valid && contactForm.get('contactFormEmail').dirty) || (contactForm.get('contactFormEmail').touched && contactForm.get('contactFormEmail').pristine) ? 'TextFiledError' : '' ">
                                                            <mat-form-field appearance="outline">
                                                                <mat-label>电子邮件*</mat-label>
                                                                <input matInput placeholder=""
                                                                    formControlName="contactFormEmail"
                                                                    class="form-control">
                                                            </mat-form-field>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6 leftPaddingRemove">
                                                        <div class="textbox_content form-group"
                                                            [ngClass]="(!contactForm.get('contactphoneNo').valid && contactForm.get('contactphoneNo').dirty) || (contactForm.get('contactphoneNo').touched && contactForm.get('contactphoneNo').pristine) ? 'TextFiledError' : '' ">
                                                            <mat-form-field appearance="outline">
                                                                <mat-label>联络电话*（包括国际代码）</mat-label>
                                                                <input type="number" matInput placeholder=""
                                                                    formControlName="contactphoneNo"
                                                                    class="form-control">
                                                            </mat-form-field>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="form-group text-center">
                                                    <button type="submit" [disabled]="isSubmitting">送出</button>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="thank_section contact_us_form" *ngIf="thankSection" style="padding: 30px 0px 0 0;">
                                <div class="form-group">
                                    <h2>感谢您！</h2>
                                    <p>我们会尽快和您联络。</p>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>